import React from "react";
import RoadmapLarge from "../../RoadmapLarge/m24";
import { IRoadmapSmallProps } from "@/types/RoadmapSmallTypes";
import { INiuNiuHistoryType } from "@/types/GameHistoryTypes";

interface IProps extends Omit<IRoadmapSmallProps, "history"> {
	history: INiuNiuHistoryType[];
}

export default class M24 extends React.Component<IProps> {
	render() {
		const p = this.props;
		
		return <RoadmapLarge
					pcode={p.pcode}
					history={p.history}
					type={"bottom"}
					small={true} />;
	}
}